// components\MQTTService.tsx
import mqtt from 'mqtt';
import { compressMessage } from './utils//MQTTMessageMapper'; // ✅ 경로와 파일명 반드시 확인

class MQTTService {
  private static instance: MQTTService;
  private client: mqtt.MqttClient;
  private brokerUrl = process.env.REACT_APP_MQTT_BROKER_URL || 'wss://mqtt.i2r.link';


  private constructor() {
    this.client = mqtt.connect(this.brokerUrl);
    //this.client.on('connect', () => console.log('✅ Connected to MQTT broker'));
    this.client.on('error', (err) => console.error('❌ MQTT Error:', err));
    /*
    this.client.on('connect', () => {
      console.log('Connected to MQTT broker');
    });

    this.client.on('error', (error) => {
      console.error('MQTT Connection Error:', error);
    });
    */
  }

  public static getInstance(): MQTTService {
    if (!MQTTService.instance) {
      MQTTService.instance = new MQTTService();
    }
    return MQTTService.instance;
  }


  public getClient(): mqtt.MqttClient {
    return this.client;
  }


  public publish(topic: string, fullMessage: string): void {
    try {
      const original = JSON.parse(fullMessage);
      const compressed = compressMessage(original); // ✅ 축약 변환
      //const message = JSON.stringify(compressed);

      // ✅ 다시 문자열로 변환 (publish용)
      const payload = JSON.stringify(compressed);
      /*
      console.groupCollapsed(`📤 MQTT Publish to ${topic}`);
      console.log('Full message:', original);
      console.log('Compressed message:', compressed);
      console.log('Payload string:', payload);
      console.groupEnd();
      */
      this.client.publish(topic, payload, (err) => {
        if (err) {
          console.error('Publish Error:', err);
        } else {
          //console.log(`✅ ==== MQTT publish to ${topic}:`, message);
        }
      });
    } catch (error) {
      console.error('Error parsing or publishing MQTT message:', error);
    }
  }

}

export default MQTTService;
